import { Link } from "react-router-dom"
import { ROUTES } from "../Routes"

const HeroSection = () => {
    return (
        <section className="hero">
            <div className="particles">
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
            </div>
            <div className="crypto-coins">
                <div className="crypto-coin">$</div>
                <div className="crypto-coin">C</div>
                <div className="crypto-coin">N</div>
                <div className="crypto-coin">7</div>
            </div>
            <div className="hero-content">
                <span className="hero-badge">Social Casino Entertainment</span>
                <h1><span className="highlight">Zonra</span> Slots</h1>
                <p className="hero-subtitle">
                    <em>An Exciting</em> Social Casino Journey <em>Awaits You!</em><br />
                    Free-to-play entertainment with a crypto twist. No real money involved.
                </p>
                <div className="hero-buttons">
                    <Link to={ROUTES.GAME} className="btn btn-primary">Play Now</Link>
                    <a href="#features" className="btn btn-secondary">Learn More</a>
                </div>
            </div>
        </section>
    )
}

export default HeroSection